import Env from '../../util/env';
import {
	serviceURL,
	riskTypeIds,
	accountTypeIds,
	executionTypeIds,
	jsonDocumentPatchOperations
} from '../../util/uiconstants';
import {
	CLEAR_SELECTED_RECONCILIATION,
	GET_RECONCILIATION_ACCOUNTS,
	GET_RECONCILIATION_RISKS,
	GET_ALL_RECONCILIATIONS,
	UPDATE_RECONCILIATION_ACCOUNT,
	UPDATE_RECONCILIATION_RISK,
	UPDATE_GROUP_COMPONENT_ACCOUNT,
	UPDATE_GROUP_COMPONENT_RISK
} from '../actiontypes';
import {patchGeneratorPayload} from './patchGeneratorPayload';

import mock from './mock';
import Utility from '../../util/utilityfunctions';

const getReconciliationsBaseUrl = (projectId) => `${Env.getBaseURL(serviceURL)}projects/${projectId}/Reconciliations`;

export const getAllReconciliations = ({projectId, primaryEngagementId, entities}) => ({
	type: GET_ALL_RECONCILIATIONS,
	meta: {
		api: {
			url: `${getReconciliationsBaseUrl(projectId)}/${primaryEngagementId}?accountTypeIds=${
				accountTypeIds.significantAccount
			}&accountTypeIds=${accountTypeIds.significantDisclosure}&executionTypeIds=${
				executionTypeIds.executedInThisEngagement
			}&executionTypeIds=${executionTypeIds.groupExecutedInComponentEngagement}&executionTypeIds=${
				executionTypeIds.groupExecutedInPrimaryAndComponentEngagement
			}&riskTypeIds=${riskTypeIds.fraud}&riskTypeIds=${riskTypeIds.insignificant}&riskTypeIds=${
				riskTypeIds.significant
			}`,
			method: 'GET'
		}
	},
	primaryEngagementId,
	entities
});

export const getAllReconciliationsNoEngagementSelected = ({primaryEngagementId, entities}) => ({
	type: GET_ALL_RECONCILIATIONS,
	primaryEngagementId,
	entities
});

export const clearSelectedReconciliation = () => ({
	type: CLEAR_SELECTED_RECONCILIATION
});

export const getReconciliationAccounts = (componentId, {projectId, primaryEngagementId}) => ({
	type: GET_RECONCILIATION_ACCOUNTS,
	meta: {
		api: {
			url: `${getReconciliationsBaseUrl(
				projectId
			)}/${primaryEngagementId}/components/${componentId}/Accounts?accountTypeIds=${
				accountTypeIds.significantAccount
			}&accountTypeIds=${accountTypeIds.significantDisclosure}&executionTypeIds=${
				executionTypeIds.executedInThisEngagement
			}&executionTypeIds=${executionTypeIds.groupExecutedInComponentEngagement}&executionTypeIds=${
				executionTypeIds.groupExecutedInPrimaryAndComponentEngagement
			}`,
			method: 'GET'
		}
	}
});

export const getReconciliationRisks = (componentId, {projectId, primaryEngagementId}) => ({
	type: GET_RECONCILIATION_RISKS,
	meta: {
		api: {
			url: `${getReconciliationsBaseUrl(
				projectId
			)}/${primaryEngagementId}/components/${componentId}/Risks?accountTypeIds=${
				accountTypeIds.significantAccount
			}&accountTypeIds=${accountTypeIds.significantDisclosure}&executionTypeIds=${
				executionTypeIds.executedInThisEngagement
			}&executionTypeIds=${executionTypeIds.groupExecutedInComponentEngagement}&executionTypeIds=${
				executionTypeIds.groupExecutedInPrimaryAndComponentEngagement
			}&riskTypeIds=${riskTypeIds.fraud}&riskTypeIds=${riskTypeIds.insignificant}&riskTypeIds=${
				riskTypeIds.significant
			}`,
			method: 'GET'
		}
	}
});

export const updateReconciliationAccount = (accountId, payload, {projectId, primaryEngagementId}) => {
	const data = [];

	if (payload.RelatedComponentAccounts) {
		const {componentAccountsToAdd = [], componentAccountsToRemove = []} = payload.RelatedComponentAccounts;
		componentAccountsToAdd.length > 0 && data.push(
			Utility.getJsonPatchDocumentElement(
				jsonDocumentPatchOperations.add,
				'RelatedComponentAccounts',
				componentAccountsToAdd
			)
		);
		componentAccountsToRemove.length > 0 && data.push(
			Utility.getJsonPatchDocumentElement(
				jsonDocumentPatchOperations.remove,
				'RelatedComponentAccounts',
				componentAccountsToRemove
			)
		);
	} else {
		data.push(...patchGeneratorPayload(payload));
	}

	return {
		type: UPDATE_RECONCILIATION_ACCOUNT,
		meta: {
			api: {
				url: `${getReconciliationsBaseUrl(projectId)}/${primaryEngagementId}/accounts/${accountId}`,
				method: 'PATCH',
				data: data
			}
		},
		payload
	};
};

export const updateReconciliationRisk = (riskId, payload, {projectId, primaryEngagementId}) => {
	const data = [];

	if (payload.groupRiskStatusId) {
		data.push(
			Utility.getJsonPatchDocumentElement(
				jsonDocumentPatchOperations.replace,
				'GroupRiskStatusId',
				payload.groupRiskStatusId
			)
		);
	}

	if (payload.RelatedComponentRisks) {
		const {componentRisksToAdd = [], componentRisksToRemove = []} = payload.RelatedComponentRisks;
		componentRisksToAdd.length > 0 && data.push(
			Utility.getJsonPatchDocumentElement(jsonDocumentPatchOperations.add, 'RelatedComponentRisks', componentRisksToAdd)
		);
		componentRisksToRemove.length > 0 && data.push(
			Utility.getJsonPatchDocumentElement(
				jsonDocumentPatchOperations.remove,
				'RelatedComponentRisks',
				componentRisksToRemove
			)
		);
	}

	return {
		type: UPDATE_RECONCILIATION_RISK,
		meta: {
			api: {
				url: `${getReconciliationsBaseUrl(projectId)}/${primaryEngagementId}/Risks/${riskId}`,
				method: 'PATCH',
				data: data
			}
		},
		payload
	};
};

export const updateGroupComponentAccount = (
	primaryAccountId,
	groupComponentAccountId,
	payload,
	{projectId, primaryEngagementId}
) => {
	// updates rationale
	const data = patchGeneratorPayload(payload);

	return {
		type: UPDATE_GROUP_COMPONENT_ACCOUNT,
		meta: {
			api: {
				url: `${getReconciliationsBaseUrl(
					projectId
				)}/${primaryEngagementId}/accounts/${primaryAccountId}/comments/${groupComponentAccountId}`,
				method: 'PATCH',
				data: data
			}
		},
		payload
	};
};

export const updateGroupComponentRisk = (
	primaryRiskId,
	groupComponentRiskId,
	payload,
	{projectId, primaryEngagementId}
) => {
	// updates rationale
	const data = patchGeneratorPayload(payload);

	return {
		type: UPDATE_GROUP_COMPONENT_RISK,
		meta: {
			api: {
				url: `${getReconciliationsBaseUrl(
					projectId
				)}/${primaryEngagementId}/risks/${primaryRiskId}/comments/${groupComponentRiskId}`,
				method: 'PATCH',
				data: data
			}
		},
		payload
	};
};
